// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_user.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_user.proto.
 */
export const file_travplaces_v1_admin_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * User is an operator account. There is no password field, in either
 * direction, on purpose.
 *
 * @generated from message travplaces.v1.User
 */
export type User = Message<"travplaces.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * What to call this operator on screen. Empty where none was given, and
   * every reader falls back to the username, which is what they showed
   * before the field existed.
   *
   * @generated from field: string display_name = 6;
   */
  displayName: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * @generated from field: string role_name = 4;
   */
  roleName: string;

  /**
   * Whether this is the account making the request, so the console can leave
   * out a Delete button that the server would refuse anyway.
   *
   * @generated from field: bool is_self = 5;
   */
  isSelf: boolean;
};

/**
 * Describes the message travplaces.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 0);

/**
 * SetUserName renames the person, never the login. A username is what a
 * session, an audit row and a saved plan's "saved by" are written against, so
 * changing it would orphan the record; the display name has no such job.
 *
 * @generated from message travplaces.v1.SetUserNameRequest
 */
export type SetUserNameRequest = Message<"travplaces.v1.SetUserNameRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message travplaces.v1.SetUserNameRequest.
 * Use `create(SetUserNameRequestSchema)` to create a new message.
 */
export const SetUserNameRequestSchema: GenMessage<SetUserNameRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 1);

/**
 * @generated from message travplaces.v1.SetUserNameResponse
 */
export type SetUserNameResponse = Message<"travplaces.v1.SetUserNameResponse"> & {
  /**
   * @generated from field: travplaces.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message travplaces.v1.SetUserNameResponse.
 * Use `create(SetUserNameResponseSchema)` to create a new message.
 */
export const SetUserNameResponseSchema: GenMessage<SetUserNameResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 2);

/**
 * @generated from message travplaces.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"travplaces.v1.ListUsersRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 3);

/**
 * @generated from message travplaces.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"travplaces.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message travplaces.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 4);

/**
 * @generated from message travplaces.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"travplaces.v1.CreateUserRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * Optional: the account works without one.
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;
};

/**
 * Describes the message travplaces.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 5);

/**
 * @generated from message travplaces.v1.CreateUserResponse
 */
export type CreateUserResponse = Message<"travplaces.v1.CreateUserResponse"> & {
  /**
   * @generated from field: travplaces.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message travplaces.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 6);

/**
 * @generated from message travplaces.v1.SetUserRoleRequest
 */
export type SetUserRoleRequest = Message<"travplaces.v1.SetUserRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message travplaces.v1.SetUserRoleRequest.
 * Use `create(SetUserRoleRequestSchema)` to create a new message.
 */
export const SetUserRoleRequestSchema: GenMessage<SetUserRoleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 7);

/**
 * @generated from message travplaces.v1.SetUserRoleResponse
 */
export type SetUserRoleResponse = Message<"travplaces.v1.SetUserRoleResponse"> & {
  /**
   * @generated from field: travplaces.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message travplaces.v1.SetUserRoleResponse.
 * Use `create(SetUserRoleResponseSchema)` to create a new message.
 */
export const SetUserRoleResponseSchema: GenMessage<SetUserRoleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 8);

/**
 * @generated from message travplaces.v1.ResetUserPasswordRequest
 */
export type ResetUserPasswordRequest = Message<"travplaces.v1.ResetUserPasswordRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message travplaces.v1.ResetUserPasswordRequest.
 * Use `create(ResetUserPasswordRequestSchema)` to create a new message.
 */
export const ResetUserPasswordRequestSchema: GenMessage<ResetUserPasswordRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 9);

/**
 * @generated from message travplaces.v1.ResetUserPasswordResponse
 */
export type ResetUserPasswordResponse = Message<"travplaces.v1.ResetUserPasswordResponse"> & {
  /**
   * @generated from field: bool updated = 1;
   */
  updated: boolean;
};

/**
 * Describes the message travplaces.v1.ResetUserPasswordResponse.
 * Use `create(ResetUserPasswordResponseSchema)` to create a new message.
 */
export const ResetUserPasswordResponseSchema: GenMessage<ResetUserPasswordResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 10);

/**
 * @generated from message travplaces.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"travplaces.v1.DeleteUserRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 11);

/**
 * @generated from message travplaces.v1.DeleteUserResponse
 */
export type DeleteUserResponse = Message<"travplaces.v1.DeleteUserResponse"> & {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted: boolean;
};

/**
 * Describes the message travplaces.v1.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema: GenMessage<DeleteUserResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_user, 12);

/**
 * AdminUserService manages operator accounts.
 *
 * Until this existed the only account was the one the migrations seeded, and
 * the only way to add another was a SQL prompt. Passwords never travel out of
 * here — an account is returned without one, and there is no procedure that
 * reads one back.
 *
 * @generated from service travplaces.v1.AdminUserService
 */
export const AdminUserService: GenService<{
  /**
   * ListUsers returns every account and the role it holds.
   *
   * @generated from rpc travplaces.v1.AdminUserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * CreateUser adds an account with an initial password.
   *
   * @generated from rpc travplaces.v1.AdminUserService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * SetUserName changes what an operator is called on screen.
   *
   * @generated from rpc travplaces.v1.AdminUserService.SetUserName
   */
  setUserName: {
    methodKind: "unary";
    input: typeof SetUserNameRequestSchema;
    output: typeof SetUserNameResponseSchema;
  },
  /**
   * SetUserRole moves an account onto a different role.
   *
   * @generated from rpc travplaces.v1.AdminUserService.SetUserRole
   */
  setUserRole: {
    methodKind: "unary";
    input: typeof SetUserRoleRequestSchema;
    output: typeof SetUserRoleResponseSchema;
  },
  /**
   * ResetUserPassword sets a new password for an account whose holder cannot
   * sign in to change it themselves.
   *
   * @generated from rpc travplaces.v1.AdminUserService.ResetUserPassword
   */
  resetUserPassword: {
    methodKind: "unary";
    input: typeof ResetUserPasswordRequestSchema;
    output: typeof ResetUserPasswordResponseSchema;
  },
  /**
   * DeleteUser removes an account. Refused for your own account, and refused
   * if it would remove the last account able to manage users.
   *
   * @generated from rpc travplaces.v1.AdminUserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof DeleteUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_user, 0);

